import React from 'react';
import { block } from '../../utils';
import './ErrorWrapper.css';
const b = block('error-wrapper');
export const ErrorWrapper = ({ name, meta, withoutChildErrorStyles, children, className, }) => {
    const error = React.useMemo(() => {
        if ((meta.touched || meta.submitFailed) && meta.error) {
            return meta.error;
        }
        return;
    }, [meta.touched, meta.submitFailed, meta.error]);
    const props = React.useMemo(() => (meta.error ? { 'data-form-error': true, 'data-form-error-name': name } : {}), [meta.error, name]);
    return (React.createElement("span", Object.assign({ className: b({ error: !withoutChildErrorStyles && Boolean(error) }, className) }, props),
        children,
        error && typeof error === 'string' ? (React.createElement("div", { className: b('error-text') }, error)) : null));
};
